import React, { useState, useEffect, useRef } from "react";
// import axios from "axios";
import $ from "jquery";
import { useStateContext } from "../../context/ContextProvider";
import { useNavigate } from "react-router-dom";
import { BsPhone, BsLaptop } from "react-icons/bs";
import Loading from "../Loading/Loading";

const WebMobileAppForm = ({
    leadSource,
    language
}) => {
    const {
        BACKEND_URL,
        t,
        userInfo
    } = useStateContext();

    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        name: "",
        phone: "",
        email: "",
        businessName: "",
        country: userInfo?.countryName ?? "",
        language: language ?? "English",
        leadSource: leadSource ?? "Website",
        filename: "",
        ip: userInfo?.ip ?? "",
        device: userInfo?.userAgent ?? ""
    });
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [countryCode, setCountryCode] = useState("");
    const [localNumber, setLocalNumber] = useState("");
    const [isValid, setIsValid] = useState(true);

    const contactFieldRef = useRef(null);
    const contactErrorRef = useRef(null);
    const submitBtnRef = useRef(null);

    let clickId = null;

    // DEVICE 
    useEffect(() => {
        console.log("IN FORM: ", userInfo);
        setFormData((prevData) => ({
            ...prevData,
            device: userInfo?.userAgent,
        }));
    }, [userInfo]);

    // URL PATH / FILENAME 
    useEffect(() => {
        const path = window.location.pathname;
        const query = window.location.search;
        const fullPath = path + query;
        setFormData((prevData) => ({
            ...prevData,
            filename: fullPath,
        }));
    }, []);

    // SOURCE OF LEAD 
    useEffect(() => {
        // GET CURRENT URL
        const urlParams = new URLSearchParams(window.location.search.toLowerCase());
        console.log(urlParams);
        if (urlParams.has("gclid")) {
            leadSource = "GoogleAds";
            clickId = urlParams.get("gclid");
        } else if (urlParams.has("ttclid")) {
            leadSource = "TikTok";
            clickId = urlParams.get("ttclid");
        } else if (urlParams.has("sccid")) {
            leadSource = "Snapchat";
            clickId = urlParams.get("sccid");
        } else if (urlParams.has("fbclid")) {
            leadSource = "Facebook";
            clickId = urlParams.get("fbclid");
        } else if (urlParams.has("twclid")) {
            leadSource = "Twitter";
            clickId = urlParams.get("twclid");
        } else {
            leadSource = formData.leadSource;
        }
        setFormData((prevData) => ({
            ...prevData,
            leadSource: leadSource,
            clickId: clickId
        }));
    }, []);

    // PHONE NUMBER 
    useEffect(() => {
        const phoneField = contactFieldRef.current;
        const fetchIPData = async () => {
            try {
                // IP 
                const response = await fetch("https://ipinfo.io/json");
                const data = await response.json();
                const userIp = data.ip || "";
                const countryCode = data.country || "ae";

                // TEL INPUT
                const intlTelInputInstance = window.intlTelInput(contactFieldRef.current, {
                    separateDialCode: true,
                    initialCountry: "auto",
                    geoIpLookup: (callback) => {
                        callback(countryCode);
                    },
                    utilsScript:
                        "//cdnjs.cloudflare.com/ajax/libs/intl-tel-input/24.3.3/js/utils.js",
                });

                // SET INITIAL FORM DATA 
                setFormData((prevData) => ({
                    ...prevData,
                    country: intlTelInputInstance.getSelectedCountryData().name,
                    ip: userIp,
                }));

                // ON COUNTRY CHANGE 
                phoneField.addEventListener("countrychange", () => {
                    const countryData = intlTelInputInstance.getSelectedCountryData();
                    setFormData((prevData) => ({
                        ...prevData,
                        country: countryData.name,
                        ip: userIp
                    }));
                });

                // INPUT VALIDATION 
                // contactFieldRef.current
                phoneField.addEventListener("input", () => {
                    const phoneNumber = intlTelInputInstance.getNumber();
                    const countryCode = intlTelInputInstance.getSelectedCountryData().dialCode;
                    setCountryCode(countryCode);
                    if (intlTelInputInstance.isValidNumber()) {
                        setIsValid(true);
                        contactErrorRef.current.textContent = "";
                        submitBtnRef.current.removeAttribute("disabled");
                        const localPhoneNumber = phoneNumber.replace(`+${countryCode}`, "");
                        setLocalNumber(localPhoneNumber);

                        setFormData((prevData) => ({
                            ...prevData,
                            phone: phoneNumber,
                        }));
                    } else {
                        setIsValid(false);
                        contactErrorRef.current.textContent = t("validation_phone");
                        submitBtnRef.current.setAttribute("disabled", "true");
                    }
                });

                // CLEAN UP ON UNMOUNT 
                return () => {
                    if (intlTelInputInstance) {
                        intlTelInputInstance.destroy();
                    }
                };
            } catch (error) {
                console.error("Failed to fetch IP and country information", error);
            }
        };
        fetchIPData();
    }, []);

    // HANDLE CHANGE
    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "phone") {
            setFormData((prevData) => ({
                ...prevData,
                phone: countryCode + value,
            }));
        } else {
            setFormData((prevData) => ({
                ...prevData,
                [name]: value,
            }));
        }
    };

    // VALIDATE FORM DATA
    const validate = () => {
        const newErrors = {};
        if (!formData.name) newErrors.name = t("validation_name");
        if (!formData.phone) newErrors.phone = t("validation_phone");
        if (!formData.businessName) newErrors.businessName = t("validation_businessName");
        if (!formData.service) newErrors.service = t("validation_service");
        return newErrors;
    };

    // HANDLE FORM SUBMISSION
    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log("Form submitted: ", formData);

        // Validate form
        const newErrors = validate();
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }
        setErrors(newErrors);
        setLoading(true);

        try {
            // AJAX CALL 
            $.ajax({
                url: `${BACKEND_URL}backend/controllers/SendServiceEnquiryMail.php`,
                method: "POST",
                contentType: "application/json",
                data: JSON.stringify(formData),
                dataType: "json",
                success: function (response) {
                    console.log("Response from backend:", response);
                    if (response.success) {
                        console.log("Form submitted successfully.");
                    } else {
                        console.error("Backend returned an error:", response.status);
                    }
                    setLoading(false);
                    navigate("/thankyou");
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    console.error("AJAX Error:", textStatus, errorThrown);
                    console.log("Response Text:", jqXHR.responseText);
                }
            });

            // AXIOS 
            // const response = await axios
            //     .post(
            //         `${url}backend/controllers/AddLeadSendMail.php`,
            //         // `../../../backend/controllers/AddLeadSendMail.php`,
            //         formData,
            //         {
            //             headers: {
            //                 "Content-Type": "application/json",
            //             },
            //         }
            //     )
            //     .then(response => {
            //         console.log(response.data);
            //     })
            //     .catch(error => {
            //         console.error("There was an error!", error);
            //     });
            // // HANDLE RESPONSE
            // if (response.data.success) {
            //     console.log("Form submitted successfully.");
            //     console.log("Response from backend:", response.data);
            //     // navigate("/thank-you");
            // } else {
            //     console.error("Backend returned an error:", response.data.status);
            // }

        } catch (error) {
            console.error(error);
            setLoading(false);
        }
    };

    return (
        <>
            {loading && (
                <Loading />
            )}
            <div className="mb-5 flex justify-center items-center">
                <div className="form-container" id="form-container">
                    <div className="blur-effect"></div>
                    <form
                        id="lead-form"
                        name="lead-form"
                        // dir="ltr"
                        onSubmit={handleSubmit}
                    >
                        {/* NAME */}
                        <label htmlFor="name" className="mt-0">
                            <span>
                                {t("name")}
                            </span>
                        </label>
                        <input
                            type="text"
                            name="name"
                            id="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                            autoComplete="true"
                        />
                        {errors.name && (
                            <small className="bg-red-600 text-white">
                                {errors.name}
                            </small>
                        )}

                        {/* CONTACT NUMBER */}
                        <label htmlFor="phone">
                            <span>
                                {t("contact")}
                            </span>
                        </label>
                        <div dir="ltr">
                            <input
                                type="tel"
                                ref={contactFieldRef}
                                name="phone"
                                id="phone"
                                placeholder="** *** ****"
                                value={localNumber}
                                onChange={handleChange}
                                required
                                autoComplete="true"
                            />
                        </div>
                        <small id="contactError" ref={contactErrorRef} className="bg-red-600 text-white"></small>

                        {/* EMAIL */}
                        <label htmlFor="email" >
                            {t("email")}
                        </label>
                        <input
                            type="text"
                            name="email"
                            id="email"
                            value={formData.email}
                            onChange={handleChange}
                            required={false}
                            autoComplete="true"
                        />
                        {errors.email && (
                            <small className="bg-red-600 text-white">
                                {errors.email}
                            </small>
                        )}

                        {/* BUSINESS NAME */}
                        <label htmlFor="businessName" >
                            <span>
                                {t("businessName")}
                            </span>
                        </label>
                        <input
                            type="text"
                            name="businessName"
                            id="businessName"
                            value={formData.businessName}
                            onChange={handleChange}
                            required
                            autoComplete="true"
                        />
                        {errors.businessName && (
                            <small className="bg-red-600 text-white">
                                {errors.businessName}
                            </small>
                        )}

                        {/* SERVICES */}
                        <label>
                            <span>
                                {t("services")}
                            </span>
                        </label>
                        <div className="grid grid-cols-2 gap-4 text-center">
                            <div className="service-radio flex">
                                <input className="mx-2" type="radio" name="service" id="ServiceRadio1" value="Website" required onChange={handleChange} />
                                <label htmlFor="ServiceRadio1" className="m-0 flex flex-col items-center justify-center gap-2">
                                    <BsLaptop size={32} />
                                    <div className="px-2">
                                        {t("website")}
                                    </div>
                                </label>
                            </div>
                            <div className="service-radio flex">
                                <input className="mx-2" type="radio" name="service" id="ServiceRadio2" value="Mobile Apps" required onChange={handleChange} />
                                <label htmlFor="ServiceRadio2" className="m-0 flex flex-col items-center justify-center gap-2">
                                    <BsPhone size={32} />
                                    <div className="px-2">
                                        {t("mobileApps")}
                                    </div>
                                </label>
                            </div>
                            <div className="service-radio flex col-span-2">
                                <input className="mx-2" type="radio" name="service" id="ServiceRadio3" value="Website and Mobile Apps" required onChange={handleChange} />
                                <label htmlFor="ServiceRadio3" className="m-0 flex flex-col items-center justify-center gap-2">
                                    <div className="flex gap-5 items-center justify-center">
                                        <BsLaptop size={32} />
                                        <span>+</span>
                                        <BsPhone size={32} />
                                    </div>
                                    <div className="px-2">
                                        {t("websiteMobileApps")}
                                    </div>
                                </label>
                            </div>
                        </div>
                        {errors.service && (
                            <small className="bg-red-600 text-white">
                                {errors.service}
                            </small>
                        )}

                        <div className="mt-5">
                            <button
                                type="submit"
                                className="submit-btn"
                                ref={submitBtnRef}
                                disabled={true}
                            >
                                {t("submit")}
                            </button>
                        </div>

                    </form>
                </div>
            </div>

        </>
    );
};
export default WebMobileAppForm;